import { Box } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { Button } from "../../../../controls";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../POS";
import { formatDecimal, lsGet, useFormatPrice } from "../../../../hooks/Method";

const Accounts = () => {
  const activeReg = lsGet("activeReg");
  const formatPrice = useFormatPrice();
  const { cartData, setCartData } = useContext(CartContext);
  const navigate = useNavigate();

  // Get Tax Rate
  useEffect(() => {
    if (activeReg && activeReg.outlet && activeReg.outlet.tax) {
      var taxDtls = activeReg.outlet.tax;
      setCartData((j) => ({
        ...j,
        taxRate: taxDtls.rate || 0,
        taxId: taxDtls.id || "",
      }));
    } else setCartData((j) => ({ ...j, taxRate: 0, taxId: "" }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCartData((j) => {
      var _subtotal = j.sellItems
        .map((item) => item.totalPrice)
        .reduce((x, y) => x + y, 0);

      var _totalItem = j.sellItems
        .map((item) => parseFloat(item.qty))
        .reduce((x, y) => x + y, 0);

      return {
        ...j,
        subtotal: formatDecimal(_subtotal),
        netPayable: formatDecimal(_subtotal),
        totalItems: _totalItem,
      };
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData.sellItems]);

  // Calculate the discount amount.
  useEffect(() => {
    var _disAmt = 0;
    if (cartData.disType === 1)
      _disAmt = cartData.subtotal * (parseFloat(cartData.discount || 0) / 100);
    else _disAmt = cartData.discount;

    setCartData((j) => ({
      ...j,
      disAmt: formatDecimal(_disAmt),
    }));

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData.discount, cartData.disType, cartData.subtotal]);

  // Calculate Tax
  useEffect(() => {
    var taxAmt =
      (cartData.subtotal - (cartData.disAmt || 0)) *
      (parseFloat(cartData.taxRate) / 100);
    setCartData((j) => ({ ...j, taxAmt: formatDecimal(taxAmt) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData.netPayable, cartData.taxRate]);

  // Calculate Amounts
  useEffect(() => {
    setCartData((j) => ({
      ...j,
      netPayable: formatDecimal(j.subtotal + j.taxAmt - (j.disAmt || 0)),
    }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData.subtotal, cartData.disAmt, cartData.taxAmt]);

  return (
    <>
      <Box className="text-gray-500 mt-[5px] grid gap-1">
        <Box className="flex justify-between pl-[20px] pr-[20px] mt-[8px]">
          <span className="text-[16px]">Subtotal:</span>
          <span className="text-[18px] font-medium">
            {formatPrice(cartData.subtotal)}
          </span>
        </Box>
        <Box className="flex justify-between pl-[20px] pr-[20px] mt-[8px]">
          <span className="text-[16px]">Tax ({cartData.taxRate || 0}%):</span>
          <span className="text-[18px] font-medium">
            {formatPrice(cartData.taxAmt)}
          </span>
        </Box>
        <div className="p-[10px]">
          <Button
            onClick={() => navigate("checkout")}
            className="flex !justify-between"
            sx={{ p: "12px" }}
            size="large"
            fullWidth
            disabled={cartData.sellItems.some((x) => x.outOfStock)}
          >
            <div>
              <span className="text-[20px]">Pay</span>
              <span className="text-[12px] ml-[10px] font-medium">
                {cartData.totalItems} item
              </span>
            </div>

            <span className="text-[20px]">
              {formatPrice(cartData.netPayable)}
            </span>
          </Button>
        </div>
      </Box>
    </>
  );
};

export default Accounts;
